import React from 'react';
import Row from './Row';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import T from 'i18n-react';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { ServiceButton } from '../../core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { NEWS, NEWS_INDEX } from '../routing';
import type { ArticleProps } from '../../core/Articles/props';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: (props) => props.top || 0,
    marginBottom: 20,
  },
  subtitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
  link: {
    fontSize: theme.typography.pxToRem(14),
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      display: 'none !important',
    },
  },
  button: {
    marginTop: 30,
    padding: 12,
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 'bold',
    [theme.breakpoints.up('sm')]: {
      display: 'none !important',
    },
  },
  arrow: {
    color: theme.palette.primary.main,
    marginLeft: 'auto',
  },
}));

type ContainerProps = {
  news: Array<ArticleProps>,
  top?: number,
};

const Container = (props: ContainerProps) => {
  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      <Grid
        container
        alignItems="center"
        wrap="nowrap"
        style={{ marginBottom: '.5rem' }}
      >
        <Grid>
          <Typography variant="h4" className={classes.subtitle}>
            NEWS
          </Typography>
        </Grid>
        <Grid component="a" href={NEWS_INDEX} className={classes.link}>
          <span>{T.translate('seeAll')}</span>
          <ChevronRightIcon className={classes.arrow} />
        </Grid>
      </Grid>
      {props.news?.map?.((n, index, array) => (
        <Row
          key={index}
          {...n}
          href={NEWS.replace(':id', n.id)}
          border={index === array.length - 1}
        />
      ))}
      <ServiceButton
        variant="outlined"
        className={classes.button}
        component="a"
        href={NEWS_INDEX}
      >
        {T.translate('seeAll')}
      </ServiceButton>
    </div>
  );
};

export default Container;
